import { render, staticRenderFns } from "./IssuesSummary.vue?vue&type=template&id=b14dd548&scoped=true&"
import script from "./IssuesSummary.vue?vue&type=script&lang=js&"
export * from "./IssuesSummary.vue?vue&type=script&lang=js&"
import style0 from "./IssuesSummary.vue?vue&type=style&index=0&id=b14dd548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14dd548",
  null
  
)

export default component.exports